export default {
    data() {
        return {
            name: 'hola',
        };
    },
    props: {
        fulldata: Object,
    },
    methods: {

    },
}
